export default {
  "contact.index.title": "問い合わせフォーム | LINK-J",
  "contact.index.description":
    "LINK-J（一般社団法人ライフサイエンス・イノベーション・ネットワーク・ジャパン）は、再生医療・個別化医療・創薬・医療機器・ヘルスケアITをはじめ、予防・未病・健康長寿など広義のライフサイエンス分野にかかわる世界の人々や情報が交流できるようなプラットフォームを構築し、イノベーション創出のためのエコシステムを創ります。",
  "contact.index.ogSiteName": "LINK-J",
  "contact.index.ogTitle":
    "一般社団法人　ライフサイエンス・イノベーション・ネットワーク・ジャパン（LINK-J）",
  "contact.index.ogDescription":
    "LINK-J（一般社団法人ライフサイエンス・イノベーション・ネットワーク・ジャパン）は、再生医療・個別化医療・創薬・医療機器・ヘルスケアITをはじめ、予防・未病・健康長寿など広義のライフサイエンス分野にかかわる世界の人々や情報が交流できるようなプラットフォームを構築し、イノベーション創出のためのエコシステムを創ります。",
  "contact.index.pageTitle": "問い合わせフォーム",
  "contact.index.heading": "同意事項",
  "contact.index.agreement1": "1．お客様からご提供いただく個人情報は、当法人「",
  "contact.index.privacyPolicy": "個人情報保護に関する基本方針",
  "contact.index.and": "」および「",
  "contact.index.privacyPurpose": "個人情報の利用目的",
  "contact.index.manageInfo": "」に基づき管理いたします。",
  "contact.index.agreement2":
    "2．当法人がお問い合わせフォームで取得した、お客様の個人情報は、お客様への回答の目的のみに使用いたしますが、お問い合わせ内容により、当方人の提携先である三井不動産株式会社、三井不動産ビルマネジメント株式会社で対応させていただく場合がございます。",
  "contact.index.agreement2Additional":
    "その場合、提携先に、お客様の個人情報を、提供することがございますので、あらかじめご了承ください。",
  "contact.index.agreement3":
    "3．当法人がお客様へ回答する内容の一部または全部を、お客様が転載、二次利用することはできません。",
  "contact.index.agreement4":
    "4．土日祝日にいただいたお問い合わせについては、翌営業日以降の回答となりますので、あらかじめご了承ください。",
  "contact.index.agreement5":
    "5．商品・サービス等の営業に関するお問い合わせについては返信いたしかねますのでご了承ください。",
  "contact.index.agreeButton": "同意する",
  "contact.index.phoneFaxLabel": "お電話・ファックス：",
  "contact.index.telLabel": "TEL :",
  "contact.index.faxLabel": " FAX :",
  "contact.index.telNumber": "0332414911",
  "contact.index.telNumberText": "03-3241-4911",
  "contact.index.faxNumberText": "03-3241-3757",
  "contact.index.receptionHours":
    "受付時間 9:00〜17:00／土・日・祝日および当社休業日を除く",

  "contact.form.title": "問い合わせフォーム | LINK-J",
  "contact.form.description":
    "LINK-J（一般社団法人ライフサイエンス・イノベーション・ネットワーク・ジャパン）は、再生医療・個別化医療・創薬・医療機器・ヘルスケアITをはじめ、予防・未病・健康長寿など広義のライフサイエンス分野にかかわる世界の人々や情報が交流できるようなプラットフォームを構築し、イノベーション創出のためのエコシステムを創ります。",
  "contact.form.ogSiteName": "LINK-J",
  "contact.form.ogTitle":
    "一般社団法人　ライフサイエンス・イノベーション・ネットワーク・ジャパン（LINK-J）",
  "contact.form.ogDescription":
    "LINK-J（一般社団法人ライフサイエンス・イノベーション・ネットワーク・ジャパン）は、再生医療・個別化医療・創薬・医療機器・ヘルスケアITをはじめ、予防・未病・健康長寿など広義のライフサイエンス分野にかかわる世界の人々や情報が交流できるようなプラットフォームを構築し、イノベーション創出のためのエコシステムを創ります。",
  "contact.form.atomTitle":
    "一般社団法人ライフサイエンス・イノベーション・ネットワーク・ジャパン（LINK-J）",
  "contact.form.pageTitle": "問い合わせフォーム",
  "contact.form.heading": "問い合わせフォーム",
  "contact.form.contactHeader": "お問い合わせ",
  "contact.form.fullNameLabel": "氏名（漢字）",
  "contact.form.required": "必須",
  "contact.form.lastNameLabel": "姓",
  "contact.form.firstNameLabel": "名",
  "contact.form.lastNameTitle": "氏名（漢字）(姓)を入力してください",
  "contact.form.firstNameTitle": "氏名（漢字）(名)を入力してください",
  "contact.form.fullNameKanaLabel": "氏名（フリガナ）",
  "contact.form.lastNameKanaLabel": "セイ(カタカナ)",
  "contact.form.firstNameKanaLabel": "メイ(カタカナ)",
  "contact.form.lastNameKanaTitle":
    "氏名（フリガナ）(セイ)をカタカナで入力してください",
  "contact.form.firstNameKanaTitle":
    "氏名（フリガナ）(メイ)をカタカナで入力してください",
  "contact.form.phoneLabel": "電話番号",
  "contact.form.phoneTitle":
    "電話番号(数字とハイフンのみ)を入力してください 例）0312345678",
  "contact.form.emailLabel": "メールアドレス",
  "contact.form.emailTitle":
    "メールアドレス(英数記号のみ)を入力してください 例）foo@example.com",
  "contact.form.emailConfirmNote": "確認のためもう一度入力してください",
  "contact.form.emailConfirmTitle": "同じ値を入力してください",
  "contact.form.companyNameLabel": "会社名",
  "contact.form.companyNameTitle": "会社名を入力してください",
  "contact.form.companyNameKanaLabel": "会社名（フリガナ）",
  "contact.form.companyNameKanaTitle": "会社名（フリガナ）を入力してください",
  "contact.form.bodyLabel": "お問い合わせ内容",
  "contact.form.bodyTitle": "お問い合わせ内容を入力してください",
  "contact.form.confirmButton": "確認",
  "contact.form.error.prefix": "入力エラー",

  "contact.confirm.title": "問い合わせフォーム | LINK-J",
  "contact.confirm.description":
    "LINK-J（一般社団法人ライフサイエンス・イノベーション・ネットワーク・ジャパン）は、再生医療・個別化医療・創薬・医療機器・ヘルスケアITをはじめ、予防・未病・健康長寿など広義のライフサイエンス分野にかかわる世界の人々や情報が交流できるようなプラットフォームを構築し、イノベーション創出のためのエコシステムを創ります。",
  "contact.confirm.ogSiteName": "LINK-J",
  "contact.confirm.ogTitle":
    "一般社団法人　ライフサイエンス・イノベーション・ネットワーク・ジャパン（LINK-J）",
  "contact.confirm.ogDescription":
    "LINK-J（一般社団法人ライフサイエンス・イノベーション・ネットワーク・ジャパン）は、再生医療・個別化医療・創薬・医療機器・ヘルスケアITをはじめ、予防・未病・健康長寿など広義のライフサイエンス分野にかかわる世界の人々や情報が交流できるようなプラットフォームを構築し、イノベーション創出のためのエコシステムを創ります。",
  "contact.confirm.atomTitle":
    "一般社団法人ライフサイエンス・イノベーション・ネットワーク・ジャパン（LINK-J）",
  "contact.confirm.pageTitle": "問い合わせフォーム",
  "contact.confirm.heading": "問い合わせフォーム",
  "contact.confirm.contactHeader": "お問い合わせ",
  "contact.confirm.fullNameLabel": "氏名（漢字）",
  "contact.confirm.required": "必須",
  "contact.confirm.fullNameKanaLabel": "氏名（フリガナ）",
  "contact.confirm.phoneLabel": "電話番号",
  "contact.confirm.emailLabel": "メールアドレス",
  "contact.confirm.companyNameLabel": "会社名",
  "contact.confirm.companyNameKanaLabel": "会社名（フリガナ）",
  "contact.confirm.bodyLabel": "お問い合わせ内容",
  "contact.confirm.confirmationMessage":
    "以上の内容で送信します。ご確認のうえ、「この内容で送信する」ボタンを押してください。",
  "contact.confirm.noScriptMessage":
    "修正する場合は、ブラウザの戻るボタンで戻ってください。",
  "contact.confirm.backButton": "戻る",
  "contact.confirm.submitButton": "この内容で送信する",

  "contact.complete.title": "問い合わせフォーム | LINK-J",
  "contact.complete.description":
    "LINK-J（一般社団法人ライフサイエンス・イノベーション・ネットワーク・ジャパン）は、再生医療・個別化医療・創薬・医療機器・ヘルスケアITをはじめ、予防・未病・健康長寿など広義のライフサイエンス分野にかかわる世界の人々や情報が交流できるようなプラットフォームを構築し、イノベーション創出のためのエコシステムを創ります。",
  "contact.complete.ogSiteName": "LINK-J",
  "contact.complete.ogTitle":
    "一般社団法人　ライフサイエンス・イノベーション・ネットワーク・ジャパン（LINK-J）",
  "contact.complete.ogDescription":
    "LINK-J（一般社団法人ライフサイエンス・イノベーション・ネットワーク・ジャパン）は、再生医療・個別化医療・創薬・医療機器・ヘルスケアITをはじめ、予防・未病・健康長寿など広義のライフサイエンス分野にかかわる世界の人々や情報が交流できるようなプラットフォームを構築し、イノベーション創出のためのエコシステムを創ります。",
  "contact.complete.atomTitle":
    "一般社団法人ライフサイエンス・イノベーション・ネットワーク・ジャパン（LINK-J）",
  "contact.complete.pageTitle": "問い合わせフォーム",
  "contact.complete.heading": "問い合わせフォーム",
  "contact.complete.sendComplete": "送信が完了しました。",
  "contact.complete.thankYou": "この度はお問合せ頂き誠にありがとうございます。",
  "contact.complete.confirmationEmail":
    "確認の為、お客様が入力されたメールアドレス宛に返信メールをお送り致しました。",
  "contact.complete.noEmailReceived":
    "返信メールが届かない場合は、送信のトラブルもしくはご記入いただいたメールアドレスが誤っていた可能性がございますので、よろしければ下記メールアドレス宛に、お問い合わせ内容をお送りください。",
  "contact.complete.salesInquiryNotice":
    "商品・サービスの営業に関するお問い合わせ等については、内容によりご返信いたしかねる場合もございますのでご了承下さい。",
  "contact.complete.email": "E-mail : contact@link-j.org",
  "contact.complete.returnToHome": "トップページへ戻る",
} as const;
